import {
    ACTION_GET_SUPPLIERS,
    SET_SUPPLIERS,

    ACTION_POST_CREATE_SUPPLIERS,
    ACTION_PUT_UPDATE_SUPPLIERS,
    ACTION_DELETE_SUPPLIERS,
} from "@/views/suppliers/store/types/types.js"


import Swal from "sweetalert2";
import axios from '@/plugins/http/axios.js';
import config from "@/views/suppliers/config/suppliers_api.js";
import { SuppliersService } from "../../../services";
import i18n from '@/plugins/i18n';
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_GET_SUPPLIERS]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                SuppliersService.getSuppliers(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const suppliers = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_SUPPLIERS, suppliers);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_SUPPLIERS]: ({ state }, suppliers) => {

        const formdata = new FormData();
        formdata.append("nameSupplier", suppliers.nameSupplier);
        formdata.append("identificationId", suppliers.identificationId);
        formdata.append("identificationNumber", suppliers.identificationNumber);
        formdata.append("adviser", suppliers.adviser);
        formdata.append("contactNumber", suppliers.contactNumber);
        formdata.append("email", suppliers.email);
        formdata.append("imageFile", suppliers.imageFile);
        return new Promise((resolve, reject) => {

            try {
                state.loading = true;
                axios({
                    method: 'post',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/suppliers`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    },
                    data: formdata,
                    redirect: 'follow'
                })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('suppliers.actionPostCreateSuppliers.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_SUPPLIERS]: async ({ state }, suppliers) => {

        const formdata = new FormData();

        return await new Promise((resolve, reject) => {
            formdata.append("supplierId", suppliers.supplierId);
            formdata.append("nameSupplier", suppliers.nameSupplier);
            formdata.append("identificationId", suppliers.identificationId);
            formdata.append("identificationNumber", suppliers.identificationNumber);
            formdata.append("adviser", suppliers.adviser);
            formdata.append("contactNumber", suppliers.contactNumber);
            formdata.append("email", suppliers.email);
            formdata.append("imageFile", suppliers.imageFile);

            state.loading = true;
            axios({
                method: 'put',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/suppliers`,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                data: formdata,
                redirect: 'follow'
            })
                .then(async (resp) => {
                    if (resp && resp.status === 200) {

                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('suppliers.actionPutUpdateSuppliers.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });

                        resolve(resp);

                    } else {
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },

    [ACTION_DELETE_SUPPLIERS]: async ({ state }, supplierId) => {
        state.loading = true;
        return await new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'delete',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/suppliers/${supplierId}`,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },

                redirect: 'follow'
            })
                .then(async (resp) => {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('suppliers.actionDeleteSuppliers.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);

                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
}

export default actions;